module.exports = __webpack_public_path__ + "img/696cac34c7c28987637b11987d13f4c8.49564ced.png";